module.exports = __webpack_public_path__ + "img/hm_block03_02_en.e5220cdc.png";